import styles from "./styles/FollowFeedPageItem.module.scss";
import FollowPageButton from "./FollowPageButton";
import FontAwesome from "../utilities/FontAwesome";
import { capitalize } from "../../utils/StringUtilities";
import { observer } from "mobx-react";
import ClickableLink from "../utilities/ClickableLink";
import classNames from "classnames";
import useCategoryIcons from "../../hooks/useCategoryIcons";
import { useStores } from "../../stores/useStores";

interface FollowFeedProps {
  organization: OrganizationTypeOrganization;
  updateFollowersCount?: () => void;
  url: string;
  isFollowing: boolean;
}

const FollowFeedPageItem = observer((props: FollowFeedProps) => {
  const { organizationStore } = useStores();
  const type = capitalize(props.organization.type);

  const internalSchoolFeed =
    props.organization.title_organization.id ===
    organizationStore.organization.id;

  const icon = useCategoryIcons(props.organization);

  const sectionInfoClassName = classNames({
    [styles.sectionInfo]: true,
    [styles.sectionInfoNoContent]:
      internalSchoolFeed && props.organization.schoolfeed_items_count === 0,
  });

  return (
    <ClickableLink href={props.url}>
      <div className={styles.section}>
        <div className={sectionInfoClassName}>
          <div className={styles.icon}>{icon}</div>
          <div className={styles.orgContainer}>
            <div className={styles.title}>
              {props.organization.published === 0 ? "(Draft)" : ""}{" "}
              {props.organization.title}
              {!internalSchoolFeed && (
                <FontAwesome
                  name={"fa-external-link-alt"}
                  prefix={"fas"}
                  className={styles.externalLink}
                  aria-label={"External Link"}
                  title={"External Link"}
                />
              )}
            </div>
            {props.organization.type !== "organization" && (
              <div className={styles.type}>
                {!internalSchoolFeed && <span>External: </span>}
                {props.organization.title_organization.title} - {type}
              </div>
            )}
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <FollowPageButton
            initialIsFollower={props.isFollowing}
            symbolOnly={true}
            className={styles.followButton}
            size={"2x"}
            organizationTitle={props.organization.title}
            toggleFollowingOrganizationId={props.organization.id}
          />
        </div>
      </div>
    </ClickableLink>
  );
});

export default FollowFeedPageItem;
